var utils = require("enyo/utils");

/**
 * Helper that transforms incoming credits into something more repeater-friendly
 * with an ID and such.
 *
 * @param    {Array}  media  The media item
 * @returns  {Array}  The transformed array
 */
module.exports = function(media) {
    media.credits = Array.isArray(media.credits) ? media.credits.map(function(credit) {
        return {
            id:     utils.uid(),
            label:  credit[0],
            values: credit[1]
        };
    }) : [];

    return media;
};
